import React from 'react';
import { Card } from './ui/Card';
interface OfficeVisualizationProps {
  engineers: number;
  sales: number;
  quality: number;
}
export function OfficeVisualization({
  engineers,
  sales,
  quality
}: OfficeVisualizationProps) {
  const totalSlots = 100; // 10x10 grid
  return <Card className="h-full flex flex-col border-primary/10 hover:border-primary/20 transition-colors" data-id="element-187">
      <div className="flex justify-between items-center mb-6" data-id="element-188">
        <h3 className="text-sm font-medium text-text-secondary uppercase tracking-wider" data-id="element-189">
          Headcount Distribution
        </h3>
        <div className="flex items-center space-x-4 text-xs" data-id="element-190">
          <div className="flex items-center" data-id="element-191">
            <div className="w-2 h-2 rounded-full bg-primary mr-2 shadow-glow-teal-sm" data-id="element-192" />
            <span className="text-text-secondary" data-id="element-193">Eng ({engineers})</span>
          </div>
          <div className="flex items-center" data-id="element-194">
            <div className="w-2 h-2 rounded-full bg-secondary mr-2" data-id="element-195" />
            <span className="text-text-secondary" data-id="element-196">Sales ({sales})</span>
          </div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-4 bg-surface-highlight/30 rounded-lg border border-border/50" data-id="element-197">
        <div className="grid grid-cols-10 gap-1.5 w-full max-w-[300px] aspect-square" data-id="element-198">
          {Array.from({
          length: totalSlots
        }).map((_, i) => {
          let type: 'empty' | 'engineer' | 'sales' = 'empty';
          if (i < engineers) {
            type = 'engineer';
          } else if (i < engineers + sales) {
            type = 'sales';
          }
          return <div key={i} className={`
                  w-full h-full rounded-sm transition-all duration-500
                  ${type === 'engineer' ? 'bg-primary shadow-[0_0_4px_rgba(0,212,200,0.4)]' : ''}
                  ${type === 'sales' ? 'bg-secondary shadow-[0_0_4px_rgba(245,166,35,0.4)]' : ''}
                  ${type === 'empty' ? 'bg-surface-highlight/50' : ''}
                `} data-id="element-199" />;
        })}
        </div>
      </div>

      <div className="mt-6 flex justify-between items-center border-t border-border pt-4" data-id="element-200">
        <div data-id="element-201">
          <span className="text-xs text-text-secondary block mb-1" data-id="element-202">
            Product Quality
          </span>
          <div className="flex items-baseline" data-id="element-203">
            <span className="text-xl font-mono font-bold text-text-primary" data-id="element-204">
              {Math.round(quality)}
            </span>
            <span className="text-xs text-text-secondary ml-1" data-id="element-205">/ 100</span>
          </div>
        </div>
        <div className="w-24 h-1.5 bg-surface-highlight rounded-full overflow-hidden" data-id="element-206">
          <div className="h-full bg-gradient-to-r from-danger via-secondary to-primary transition-all duration-500" style={{
          width: `${quality}%`
        }} data-id="element-207" />
        </div>
      </div>
    </Card>;
}